import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", function () {
	const heroSlider = document.querySelector('.section-hero__slider');

    if (heroSlider) {
        const swiperContainer = heroSlider.querySelector('.swiper-container');

        if (swiperContainer) {
            new Swiper(swiperContainer, {
                modules: [EffectFade, Autoplay],
                slidesPerView: 1,
                speed: 2000,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                loop: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                watchOverflow: true,
                watchSlidesProgress: true,
                slideVisibleClass: 'swiper-slide-visible',
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
            });
        }
    }

});
